import { Injectable } from '@angular/core';
import { AppSettings } from './../models/canadapost-settings';

declare let window: any;

@Injectable()
export class Configuration {
    public appSettings: AppSettings;

    constructor() {
        this.appSettings = <AppSettings>window.configuration;
    }
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/configs/app.config.ts